module.exports = __webpack_public_path__ + "static/paket-wisata-murah-eropa-60a96fa8f2880451dd04f48b3b936315.png";